/* eslint-disable @next/next/no-img-element */
import EastIcon from "@mui/icons-material/East";
import { CircularProgress, Divider } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import useGetDocumentation from "@/hooks/requests/t2Pay/use-get-documentation";
import usePagination from "@/hooks/use-pagination";
import { DocumentationMessages } from "@/messages/platforms/talk2PayConnection/documentationMessages";

interface Props {
  messages: DocumentationMessages;
}

export function Documentation({ messages }: Props) {
  const pagination = usePagination();
  const { pageNumber, pageSize } = pagination;
  const { isLoading, error, data } = useGetDocumentation({ pageNumber, pageSize });

  if (isLoading) return <CircularProgress />;

  if (error || !data || !data.items.length) {
    return <MDTypography>{messages.errorLoadingStatus}</MDTypography>;
  }

  const document = data.items[0];

  const handleOnboardingClick = () => {
    if (document.onboardingUrl) {
      window.open(document.onboardingUrl, "_blank");
    }
  };

  const identificationInstructions = messages.identificationInstructions
    .split("\n")
    .map((line, index) => (
      <MDTypography
        key={index}
        variant="caption"
        color="text"
        fontWeight="regular"
        verticalAlign="middle"
      >
        {line}
      </MDTypography>
    ));

  return (
    <MDBox>
      <MDBox width="82%" mx="auto" my={4}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, lg: 7 }}>
            <MDBox mb={1}>
              <MDTypography variant="h5" fontWeight="regular">
                {document.title}
              </MDTypography>
            </MDBox>
            <MDTypography variant="body2" color="text" fontWeight="regular">
              {messages.accessOptionsInfo}
            </MDTypography>

            <MDBox pt={3}>{identificationInstructions}</MDBox>
          </Grid>

          <Grid size={{ xs: 12, lg: 4 }}>
            <MDBox height="100%" display={"flex"} justifyContent={"center"}>
              <img
                src={`data:image/png;base64,${document.onboardingQrCode}`}
                alt="QR Code"
                width={180}
                style={{ objectFit: "cover" }}
                height={"100%"}
              />
            </MDBox>
          </Grid>
        </Grid>

        <Divider />

        <Grid size={12}>
          <a
            style={{ cursor: "pointer" }}
            onClick={handleOnboardingClick}
            target="_blank"
            rel="noopener noreferrer"
          >
            <MDBox display={"flex"} alignItems={"center"}>
              <MDTypography color={"dark"} fontWeight={"bold"} mr={1} variant="body2" gap={1}>
                {messages.identificationBrowserOption}
              </MDTypography>

              <EastIcon />
            </MDBox>
          </a>
        </Grid>
      </MDBox>
    </MDBox>
  );
}
